import { z } from 'zod';
export const Strada_Get_Claim_Data_2_ConfigValidator = z.object({
    externalInputs: z.record(z.string(), z.string()).optional()
});
//# sourceMappingURL=strada-get-claim-data-2.js.map